import axios from 'axios';
import Base  from "../Base";

const url = {
  index: "/api/contact"
};

class Contact extends Base {

  static getComponents() {
    return {
      "contact-form": require("./Parts/ContactForm"),
    };
  }

  static sendMail = async (data)=>
    (await axios.post(`${url.index}`, data)).data;

}

export default Contact;
